"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var journeySummaryStyles = makeStyles_1.default(function (theme) { return ({
    summaryTitle: {
        color: theme.palette.text.primary,
    },
    summaryDescription: {
        color: theme.palette.text.primary,
    },
}); }, { name: 'Checkout4_JourneySummary' });
exports.default = journeySummaryStyles;
